export default "/storefront/client/images/live-event-hero-desktop.png";